<header class="header-6">
  <div class="branding">
    <a routerLink="/" class="nav-link">
      <clr-icon shape="dna"></clr-icon>
      <span class="title"> GALDOC </span>
    </a>
    <div class="header-nav">
      <a *ngFor="let link of links"
         [routerLink]="link.route"
         routerLinkActive="active" class="nav-link">
        <span class="nav-text">
          {{ link.title }}
        </span>
      </a>
    </div>
  </div>
  <div class="header-actions">
    <a [routerLink]="'settings'" class="nav-link nav-icon" aria-label="settings">
      <clr-icon shape="cog"></clr-icon>
    </a>
  </div>
</header>
